var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 508 285.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00deeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 40.2396,
    x2: 272.4163,
    y1: 140.1761,
    y2: 140.1761,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: -117.5608,
    x2: 469.9354,
    y1: 24.0689,
    y2: 22.8516,
    gradientTransform: "translate(.5292)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 105.6809,
    x2: 470.1451,
    y1: 156.4303,
    y2: 156.4303,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: 103.6965,
    x2: 472.1295,
    y1: 156.4303,
    y2: 156.4303,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "r",
    x1: 113.4974,
    x2: 421.3301,
    y1: 217.6246,
    y2: 217.6246,
    gradientTransform: "matrix(1.02172 0 0 .97874 -24.8708 7.4083)",
    gradientUnits: "userSpaceOnUse"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeWidth: 9.2604,
    d: "M249.8049 221.3755A120.028 120.028 0 0 1 104.431 245.804a120.028 120.028 0 0 1-59.4158-134.9075 120.028 120.028 0 0 1 116.1614-90.7567",
    transform: "rotate(0.965)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeWidth: 9.2604,
    d: "M161.3438 22.8516h309.1207"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeDashoffset: 66.1458,
    strokeWidth: 6.6146,
    d: "M178.5386 154.6662v2.6461h24.3447v18.1704c-8.2913 10.4082-23.4626 19.2288-41.4565 19.2288-29.1079 0-52.747-23.992-52.747-53.0997 0-29.1079 23.6391-53.0998 52.747-53.0998 20.8165 0 34.5765 9.7026 42.8678 21.3458l2.117-1.9405c-7.9385-10.5847-21.6986-22.0514-44.9848-22.0514-30.872 0-55.746 25.0503-55.746 55.7459 0 30.8719 24.874 55.7458 55.746 55.7458 21.875 0 37.399-11.8195 44.2791-21.3457v-21.3457z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeDashoffset: 66.1458,
    strokeWidth: 6.6146,
    d: "M229.6976 195.9463V179.893c0-10.9375 4.2339-23.8155 18.1703-23.8155l-.1764-3.1754c-10.5846.3529-16.759 6.7037-18.6995 18.5232.5292-4.2339.7056-7.9385.7056-10.761v-6.7037h-2.8226v41.9858z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeDashoffset: 66.1458,
    strokeWidth: 6.6146,
    d: "M297.9685 153.9605v4.0575c0 3.1754.1764 6.3508.5292 8.1149-2.999-7.9385-9.879-13.2309-18.876-13.2309-11.8195 0-22.2277 7.9386-22.2277 22.9335 0 13.2308 9.5261 21.5221 20.9929 21.5221 8.6441 0 16.2298-3.881 20.1108-13.5836-.3528 1.5877-.5292 4.763-.5292 8.1149v4.0574h2.8226v-41.9858zm0 23.1099c0 9.3497-8.4677 17.9939-18.5232 17.9939-10.761 0-19.0524-8.115-19.0524-19.758 0-12.1724 8.115-20.111 19.0524-20.111 10.2319 0 18.5232 8.2914 18.5232 17.994z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeDashoffset: 66.1458,
    strokeWidth: 6.6146,
    d: "m338.3664 195.9463 18.1703-41.9858h-3.1754l-16.2069 37.0416-16.2527-37.0416H317.55l18.3467 41.9858z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeDashoffset: 66.1458,
    strokeWidth: 6.6146,
    d: "M375.5891 195.9463v-41.9858h-2.8226v41.9858zm1.0585-56.0987c0-1.4113-1.0585-2.4697-2.4698-2.4697-1.4113 0-2.4697 1.0584-2.4697 2.4697s1.0584 2.4698 2.4697 2.4698 2.4698-1.0585 2.4698-2.4698z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeDashoffset: 66.1458,
    strokeWidth: 6.6146,
    d: "M408.578 195.9463v-39.5186h15.1711l-1.0583-2.4698H408.578v-21.1667l-2.8226 1.0583v20.1084h-14.1128v2.4698h14.1128v39.5186z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeDashoffset: 66.1458,
    strokeWidth: 6.6146,
    d: "M449.3287 195.5935c-2.999 7.2329-10.9375 20.2873-17.6411 29.637l2.2933 1.7642c6.88-9.879 13.76-21.875 17.8175-31.0484l18.3467-41.9858h-3.1753l-16.2299 38.634-16.2298-38.634h-3.3518z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M281.69 216.0952q1.6405 0 3.1127 1.2088l.2945.2418-1.5564 1.7326-.2945-.2417q-.8413-.6447-1.5143-.6447-.2944 0-.4206.0403-.8413.2014-1.304 1.1282-.2945.6447-.2945 1.1283 0 .3223.1683.8059.4627 1.1282 1.935 1.6924 3.281 1.2491 4.3326 3.7877.3785.8865.3785 1.8535 0 1.37-.7571 2.6192-1.346 2.1356-3.87 2.5789-.5888.0806-.9674.0806-2.3556 0-4.627-1.6521l-.2945-.2418 1.4302-1.8133.2944.2418q1.5564 1.1686 3.1128 1.1686.4206 0 .631-.0403 1.5142-.2418 2.2293-1.4507.4207-.6447.4207-1.4909 0-.6044-.2103-1.0476-.673-1.5715-2.9866-2.458-2.4397-.9268-3.239-3.0624-.2944-.806-.2944-1.6521 0-1.0477.4627-2.0148.9254-1.8535 2.8183-2.337.673-.1612 1.0096-.1612z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M293.0893 218.8755q2.4818-2.6192 6.0152-2.6192 3.5334 0 5.9731 2.6192 2.4818 2.6192 2.4818 6.286 0 3.6265-2.4818 6.2457-2.4397 2.6191-5.973 2.6191-3.5335 0-6.0153-2.6191-2.4397-2.6192-2.4397-6.2457 0-3.6668 2.4397-6.286zm10.2637 1.6118q-1.7667-1.9342-4.2485-1.9342t-4.2905 1.9342q-1.8088 1.8938-1.8088 4.6742 0 2.7803 1.8088 4.7145 1.8087 1.8938 4.2905 1.8938t4.2485-1.8938q1.8088-1.9342 1.8088-4.7145 0-2.7804-1.8088-4.6742z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M321.2723 205.82h.3786v2.2565h-.3786q-2.4817 0-4.2905 1.9341-1.8088 1.8939-1.8088 4.6742v2.8207h5.5104v2.2565h-5.5104v13.6196h-2.3556V219.762h-1.1357v-2.2565h1.1357v-2.8207q0-3.6265 2.4398-6.2457 2.4817-2.6191 6.0151-2.6191z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M329.3487 210.333v6.3666h4.3326l.8003 2.2565h-5.133v14.4255h-2.3555v-14.4255h-2.7763v-2.2565h2.7763v-5.1577z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m337.7614 216.1355 5.3422 13.5793 3.281-8.4216h2.019l3.3232 8.4216 5.3-13.5793 2.2295.8058-6.52 16.6418h-2.019l-3.3232-8.4619-3.281 8.462h-2.019l-6.52-16.6419 1.8088-.685z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M364.4722 218.8755q2.4818-2.6192 6.0152-2.6192 3.5333 0 6.0572 2.74v-2.2967h2.3977v16.682h-2.3977v-2.0953q-2.5239 2.74-6.0572 2.74-3.5334 0-6.0152-2.6191-2.4398-2.6192-2.4398-6.2457 0-3.6668 2.4398-6.286zm10.2636 1.6118q-1.7667-1.9342-4.2484-1.9342-2.4818 0-4.2906 1.9342-1.8088 1.8938-1.8088 4.6742 0 2.7803 1.8088 4.7145 1.8088 1.8938 4.2905 1.8938 2.4818 0 4.2485-1.8938 1.8088-1.9342 1.8088-4.7145 0-2.7804-1.8088-4.6742z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M392.571 216.2563h.3786v2.2968h-.3786q-2.4818 0-4.2905 1.9342-1.7667 1.8938-1.7667 4.6742v8.2201h-2.3977v-16.6821h2.3977v2.2969q2.5238-2.74 6.0572-2.74z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M403.9704 216.2563q2.7341 0 4.8794 1.6924 2.1874 1.6521 3.0707 4.231l.3365.9268-13.2502 5.8427q.8413 1.3297 2.1453 2.0953 1.304.7253 2.8183.7253 2.0611 0 3.7016-1.37l.2945-.2418 1.5563 1.6924-.2944.2418q-2.2715 1.9341-5.258 1.9341-3.5334 0-6.0152-2.6191-2.4397-2.6192-2.4397-6.2457 0-3.6668 2.4397-6.286 2.4818-2.6192 6.0152-2.6192zm0 2.2968q-2.4818 0-4.2906 1.9342-1.8087 1.8938-1.8087 4.6742 0 .8059.2103 1.6924l11.189-4.916q-.7992-1.5715-2.2293-2.458-1.3882-.9268-3.0707-.9268z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.47dc03536512a11fbd93086b4e4109ff.svg";
export { ForwardRef as ReactComponent };